
export function JsonViewer({ data }: { data: unknown }) {
  const json = JSON.stringify(data, null, 2);
  // Tokenize: strings, numbers, booleans, null, keys
  const parts = json.split(/("(?:[^"\\]|\\.)*"|\b(?:true|false|null)\b|-?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?)/g);
  return (
    <pre className="text-[11px] leading-relaxed bg-nightshade-900 text-icon-subtle rounded-lg p-3 overflow-auto max-h-80 whitespace-pre-wrap break-words font-mono">
      {parts.map((part, i) => {
        // Syntax-highlighted tokens from a deterministic regex split; position is the identity.
        if (/^".*":?$/.test(part)) {
          // Key (followed by colon in the JSON) vs string value
          // Keys are always followed by ": " in pretty-printed JSON
          // Check the next non-empty part
          const next = parts[i + 1]?.trimStart();
          if (next?.startsWith(':')) {
            // eslint-disable-next-line react/no-array-index-key -- JSON token renderer: position is identity
            return <span key={i} className="text-blueberry-400">{part}</span>;
          }
          // eslint-disable-next-line react/no-array-index-key -- JSON token renderer: position is identity
          return <span key={i} className="text-icon-success">{part}</span>;
        }
        if (part === 'true' || part === 'false') {
          // eslint-disable-next-line react/no-array-index-key -- JSON token renderer: position is identity
          return <span key={i} className="text-amber-400">{part}</span>;
        }
        if (part === 'null') {
          // eslint-disable-next-line react/no-array-index-key -- JSON token renderer: position is identity
          return <span key={i} className="text-icon-subtle">{part}</span>;
        }
        if (/^-?\d/.test(part)) {
          // eslint-disable-next-line react/no-array-index-key -- JSON token renderer: position is identity
          return <span key={i} className="text-icon-danger">{part}</span>;
        }
        // eslint-disable-next-line react/no-array-index-key -- JSON token renderer: position is identity
        return <span key={i}>{part}</span>;
      })}
    </pre>
  );
}
